/**
 * Skus Inventory
 */

// React
import React, {
  FunctionComponent,
  useEffect,
  useState,
  useContext,
} from 'react';


// Components
import Pagination from '@material-ui/lab/Pagination';
import ListSkus from './components/listSkus';
import ReportList from './components/reportList';
import ProductFilter from './components/productFilter';
import WarehouseFilter from './components/warehouseFilter';
import CartexList from './components/cartexList';
import InventoryItemsList from './components/inventoryItemsList';
// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Box,
  Checkbox,
} from '@material-ui/core';

// Helper
import { flattenObject, removeEmptyValueObject } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';

// Type
import {
  ProductFilters,
  Props,
  WarehouseFilters,
} from './interfaces';

import CSV from './components/csv';
import Icon from '@mdi/react';
import {
  mdiArchiveOutline,
  mdiCounter,
  mdiKeyOutline,
  mdiTrashCan,
  mdiVectorPolylineEdit,
} from '@mdi/js';
import Modal from '../../components/Modal';
import { GetCardIndexRequestBuilder } from 'client-sdk/src/parcels/parcels';
import Client from 'client-sdk/src/client';
import { InventoryItems } from '../parcelsSender/interfaces';
import handleError from '../../utils/handleError';
import {
  GetInventoryFlowRequestBuilder,
  GetSkusInventoryRequestBuilder,
} from 'client-sdk/src/skus/skus';
import Can from '../../components/Can';
import AuthContext from '../../authContext';
import { SkuInventory } from '../warehouses/interfaces';
import CardIndexCsv from './components/cardIndexCsv';
import skusRepository from 'client-sdk/src/Repository/skus-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import getProductFileReq from 'client-sdk/src/products/files';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    paper: {
      position: 'relative',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '30vh',
      minWidth: '50vw',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

enum Type {
  skus = 'skus',
  warehouse = 'warehouse',
}

const WarehouseInventory: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const token = localStorage.getItem('token') || '';
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [firstLook, setFirstLook] = useState(true as boolean);
  const [cartex, setCartex] = useState(false as boolean);
  const [type, setType] = useState(Type.skus);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [loadingCartex, setLoadingCartex] = useState(false as boolean);
  const [cartexData, setCartexData] = useState<null | InventoryItems[]>(null);
  const [reportModal, setReportModal] = useState(false as boolean);
  const [parcelItemsModal, setParcelItemsModal] = useState(false as boolean);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openSizeInventory, setOpenSizeInventory] = React.useState(
    false as boolean
  );
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [reportId, setReportId] = useState(null as any);
  const [csvData, setCsvData] = useState<SkuInventory[]>([]);
  const [csvDataLoading, setCsvDataLoading] = useState(false);
  const [cardIndexCsvLoading, setCardIndexCsvLoading] = useState(
    false as boolean
  );
  const [cardIndexCsvData, setCardIndexCsvData] = useState([]);
  const [reportCsvData, setReportCsvData] = useState([]);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [editable, setEditable] = useState(false)

  const [skusInventoryListCount, setSkusInventoryListCount] =
    useState<number>(0);
  const [skusInventoryList, setSkusInventoryList] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [wastage, setWastage] = useState<boolean>(false);
  const [parcelsList, setParcelsList] = useState([]);
  const [parcelLoading, setParcelLoading] = useState<boolean>(false);
  const [id, setId] = useState(-1 as number);
  const [parcelCount, setParcelCount] = useState<boolean>(false);
  const [inventoryItemsList, setInventoryItemsList] = useState([]);
  const [inventoryItemsListCount, setInventoryItemsListCount] =
    useState<number>(0);
  const [inventoryItemsListLoading, setInventoryItemsListLoading] =
    useState<boolean>(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (firstLook) {
      setFirstLook(false)
    } else {
      getSkusInventory();
    }
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      setCsvData([]);
    };
  }, [type]);

  useEffect(() => {
    id && getCardIndex(id);
    setCardIndexCsvData([]);
  }, [wastage]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeInventoryPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setInventoryFilters({ ...inventoryFilters, page: page - 1 });
    getParcelInventoryRequest({ ...inventoryFilters, page: page - 1 });
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({ ...reportFilters, page: page - 1 });
    fetchReportList(reportId, { ...reportFilters, page: page - 1 });
  };
  const getSkusInventoryReq = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const response = await skusRepository.getSkusInventory({ payload });
      setSkusInventoryList(response.data.content);
      setSkusInventoryListCount(response.data.totalElements);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getSkusInventory = () => {
    getSkusInventoryReq({
      pagination: { ...removeEmptyValueObject(filtersValues) },
    });
  };

  const handleSearchWarehouse = (values: WarehouseFilters) => {
    setFiltersValues({
      ...filtersValues,
      ...values,
      page: 0,
      size: 10,
    });
  };

  const handleSearchProduct = (values: ProductFilters) => {
    setFiltersValues({
      ...filtersValues,
      ...values,
      page: 0,
      size: 10,
    });
  };

  useEffect(() => {
    const productCode = filtersValues['productCode.equals']
    const id = filtersValues['id.equals']
    const productId = filtersValues['productId.equals']
    if ((productCode || id || productId) && skusInventoryList.length > 0) {
      setEditable(true)
    }
  }, [filtersValues])

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleCloseInventory = () => {
    setOpenSizeInventory(false);
  };

  const handleOpenCartexModal = (id: number) => {
    findSelectedItem(id);
    setId(id);
    getCardIndex(id);
    setCartex(true);
  };

  const findSelectedItem = (id: number) => {
    const findSelectSku = skusInventoryList.find((el: any) => el.id === id)!;
    setSelectedItem(findSelectSku);
  };

  const getCardIndex = async (id: number) => {
    try {
      // const flat = flattenObject(filtersValues);
      setLoadingCartex(true);
      const request = new GetCardIndexRequestBuilder()
        .params({
          // ...removeEmptyValueObject(flat),
          // page: undefined,
          'skuId.equals': id,
          'status.equals': 'LOCATED',
          size: 100,
          'wastage.specified': wastage,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setCartexData(data);
    } catch (e) {
      handleError(e.response);
    } finally {
      setLoadingCartex(false);
    }
  };

  const handleCloseCartexModal = () => {
    setCartex(false);
    setSelectedItem(null);
    setCardIndexCsvData([]);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleChangeSizePageInventory = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setInventoryFilters({
      ...inventoryFilters,
      page: 0,
      size: event.target.value,
    });
    getParcelInventoryRequest({ ...inventoryFilters, size: event.target.value });
  };

  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setReportFilters({ ...reportFilters, page: 0, size: event.target.value });
    fetchReportList(reportId, { ...reportFilters, size: event.target.value });
  };

  const handleChangeType = (types: Type) => {
    if (types !== type) {
      setType(types);
      clearFilters();
      setFiltersValues({
        page: 0,
        size: 10,
      });
    }
  };

  const clearFilters = () => {
    setFiltersValues({
      size: 10,
      page: 0,
    });
  };
  const getParcels = async (actions: any) => {
    const payload = { ...actions };
    try {
      setParcelLoading(true);
      const { response, count } = await parcelsRepository.getParcels({ payload });
      setParcelsList(response.data);
      setParcelCount(count.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setParcelLoading(false);
    }
  };
  const handleReport = (id: number) => {
    setReportModal(true);
    setReportId(id);
    fetchReportList(id);
    // getParcels({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };

  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const { page, size, ...other } = reportFilters
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject({
            other,
            pageNumber: page,
            pageSize: size
          })),
          ...args,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }
  };

  const handleCloseReportModal = () => {
    setReportModal(false);
    setFiltersValues({
      page: 0,
      size: 10,
    });
    setReportList(null);
    setReportCsvData([]);
  };

  const handleGetParcelInventory = (id: number) => {
    setParcelItemsModal(true);
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({ 'parcelId.equals': id });
  };
  const getParcelInventoryItems = async (actions: any) => {
    const payload = { ...actions };
    try {
      setInventoryItemsListLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItemsList(response.data.content);
      setInventoryItemsListCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsListLoading(false);
    }
  };
  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    getParcelInventoryItems({ ...inventoryFilters, ...arg });
  };

  const handleCloseParcelInventoryModal = () => {
    setParcelItemsModal(false);
    setInventoryFilters({
      page: 0,
      size: 10,
    });
  };

  const fetchCsvData = async () => {
    try {
      setCsvDataLoading(true);
      const makeRequest = new GetSkusInventoryRequestBuilder()
        .params(flattenObject({ ...filtersValues, size: 1000, page: undefined }))
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setCsvDataLoading(false);
    }
  };

  const fetchCardIndexCsv = async () => {
    try {
      setCardIndexCsvLoading(true);
      // @ts-ignore
      const variantId = cartexData[0].variantId!;
      const makeRequest = new GetCardIndexRequestBuilder()
        .params({
          size: 1000,
          'skuId.equals': variantId,
          'status.equals': 'LOCATED',
          'wastage.specified': wastage,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setCardIndexCsvData(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setCardIndexCsvLoading(false);
    }
  };

  const fetchReportCsv = async () => {
    try {
      setReportCsvLoading(true);
      const parcelId = selectedItem.id;
      const request = new GetInventoryFlowRequestBuilder()
        .id(parcelId)
        .params({ size: 10000 })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setReportCsvLoading(false);
    }
  };

  const downloadImage = async (id: number, name: string) => {
    try {
      const response = await getProductFileReq(id);
      const file = URL.createObjectURL(response.blob);
      const link = document.createElement('a');
      link.href = file;
      link.setAttribute(
        'download',
        name,
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={7} md={7} lg={9}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              لیست موجودی انبار
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={3}>
          <div className={classes.card}>
            <div className={classes.cardItem}>
              <Button
                fullWidth
                color="secondary"
                size="medium"
                variant={type === 'warehouse' ? 'contained' : undefined}
                onClick={() => handleChangeType(Type.warehouse)}
              >
                بخش‌های انبار
              </Button>
            </div>
            <div className={classes.cardItem}>
              <Button
                fullWidth
                color="secondary"
                size="medium"
                variant={type === 'skus' ? 'contained' : undefined}
                onClick={() => handleChangeType(Type.skus)}
              >
                کالا
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Grid container style={{ margin: '20px auto' }}>
            <Grid item xs={12}>
              <Paper
                elevation={3}
                className={classes.paper}
                variant="elevation"
                square
              >
                <Grid item xs={12}>
                  {type === 'skus' ? (
                    <ProductFilter
                      clearForm={clearFilters}
                      submitFilters={handleSearchProduct}
                    />
                  ) : (
                    <WarehouseFilter
                      clearForm={clearFilters}
                      submitFilters={handleSearchWarehouse}
                    />
                  )}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container item spacing={6}>
            <Grid item xs={12}>
              {loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <>
                            <CSV
                              loading={csvDataLoading}
                              handleCreateCSV={fetchCsvData}
                              data={csvData}
                            />
                          </>
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ListSkus
                    type={type}
                    openCartexModal={handleOpenCartexModal}
                    handleReport={handleReport}
                    data={skusInventoryList}
                    editable={editable}
                    downloadImage={downloadImage}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleClose}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(skusInventoryListCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Modal
        maxWidth="md"
        onClose={handleCloseCartexModal}
        open={cartex}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`کارتکس کالای ${selectedItem?.partnerName}`}</span>
          </div>
        }
        content={
          <React.Fragment>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiArchiveOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`نام کالا:  `}
                  </span>

                  <span>{selectedItem?.productName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`شناسه کلا:  `}
                  </span>
                  <span>{selectedItem?.productId}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCounter} size={1} className={classes.icon} />
                    {`کد کالا:  `}
                  </span>
                  <span>{selectedItem?.productCode}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    {`شناسه تنوع:  `}
                  </span>
                  <span>{selectedItem?.id}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiVectorPolylineEdit}
                      size={1}
                      className={classes.icon}
                    />
                    {`فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerName
                      ? selectedItem?.providerName
                      : selectedItem?.sellerName}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiVectorPolylineEdit}
                      size={1}
                      className={classes.icon}
                    />
                    {`کد فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerId
                      ? selectedItem?.providerId
                      : selectedItem?.sellerId}
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} md={6} lg={3} alignItems="center">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiTrashCan} size={1} />
                  </span>
                  <span style={{ color: 'red' }}>{'انبار ضایعات'}</span>
                  <div>
                    <Checkbox
                      value={wastage}
                      onChange={e => setWastage(e.target.checked)}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12}>
                {loadingCartex ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <div style={{ textAlign: 'left' }}>
                        <Can
                          role={authContext.user.role}
                          perform="skus:downloadCSV"
                          yes={() => (
                            <>
                              {cartexData?.length > 0 && (
                                <CardIndexCsv
                                  loading={cardIndexCsvLoading}
                                  handleCreateCSV={fetchCardIndexCsv}
                                  data={cardIndexCsvData}
                                />
                              )}
                            </>
                          )}
                        />
                      </div>
                      <Box mb={3} />
                    </Grid>
                    <CartexList data={cartexData} />
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </React.Fragment>
        }
      />

      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`تاریخچه ورود و خروج کالای ${selectedItem?.productName}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />

      <Modal
        fullScreen
        onClose={handleCloseParcelInventoryModal}
        open={parcelItemsModal}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`آیتم های محموله شماره ${inventoryItemsList?.[0]?.parcelId}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {inventoryItemsListLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <InventoryItemsList data={inventoryItemsList} />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeInventory}
                  onClose={handleCloseInventory}
                  onOpen={() => setOpenSizeInventory(true)}
                  value={inventoryFilters.size}
                  onChange={handleChangeSizePageInventory}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  inventoryItemsListCount / inventoryFilters.size
                )}
                color="secondary"
                page={inventoryFilters.page + 1}
                onChange={handleChangeInventoryPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

export default WarehouseInventory;
